module.exports = __webpack_public_path__ + "img/744.74cf7bf0.jpg";